import { Component, OnInit } from '@angular/core';
import { AudioType } from '../../model/audio-type';
import { AudioService } from '../../service/audio.service';

@Component({
  selector: 'app-audio-host',
  template: ''
})
export class AudioHostComponent implements OnInit {

  private alarmAudio;
  private zoneEventAudio;

  constructor(private audioService: AudioService) { }

  ngOnInit(): void {
    this.initAudio();
  }

  private initAudio(): void {
    this.alarmAudio = new Audio('/assets/audio/alarm.mp3');
    this.alarmAudio.load();
    this.zoneEventAudio = new Audio('/assets/audio/zone_event.mp3');
    this.zoneEventAudio.load();

    this.audioService.audioPlayer$.subscribe(audioType => {
      switch (audioType) {
        case AudioType.ALARM:
          this.alarmAudio.play();
          break;
        case AudioType.ZONE_EVENT:
          this.zoneEventAudio.play();
          break;
        default:
          console.warn('Unsupported audio type', audioType);
      }
    });
  }

}
